import L from 'leaflet';

/**
 * Ícono del pin como `DivIcon` (HTML/CSS), mismo criterio que el NOC (`StationMap`): evita
 * el problema conocido de Leaflet con las imágenes del marker por defecto bajo bundlers
 * (URLs de assets rotas), sin depender de assets.
 *
 * Compartido por el picker del alta/edición (`LocationMapPicker`) y el mapa de solo
 * lectura del detalle (`LocationDetailMap`): el pin debe verse idéntico en ambos.
 */
export function pinIcon(): L.DivIcon {
  return L.divIcon({
    className: 'locaciones-map__pin',
    html: '<span style="display:block;width:20px;height:20px;border-radius:50%;background:#1677ff;border:3px solid #ffffff;box-shadow:0 0 0 2px #1677ff66,0 1px 4px rgba(0,0,0,0.45);"></span>',
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });
}
